export default function Projects() {
  return <div className='text-white'></div>;
}
